<div class="wrapper">
  <span> {{ min }}{{ unit }} </span>
  <div class="container">
    <label class="label" #label>
      <div class="value">{{ unit === 'mm' ? formatValue(value * 10) : value }}{{ unit }}</div>
    </label>
    <input
      class="input"
      [class.disabled]="isDisabled"
      [min]="min"
      [max]="max"
      type="range"
      (change)="change($event)"
      (mousemove)="mouseMove($event)"
      #input
    />
  </div>
  <span> {{ unit === 'mm' ? formatValue(max * 10) : max }}{{ unit }} </span>
</div>
